import Vue from 'vue'
import axios from 'axios'
import { getToken, checkCode } from '@/assets/js/utils'
import router from '@/router'
import { service_const } from '@/assets/js/consts'
import { MessageBox } from 'element-ui'

/**
 * 字符串替换
 */
String.prototype.replaceAll = function(f, e) {
  var reg = new RegExp(f, 'g')
  return this.replace(reg, e)
}

/**
 * 页面跳转
 * @param {*} url
 */
window.toUrl = function(url, code) {
  if (code) {
    if (checkCode(code)) {
      if (_global_.UI.domain_key) {
        if (url.indexOf('?') == -1) {
          router.push(`${url}?${_global_.UI.domain_key}`)
        } else {
          router.push(`${url}&${_global_.UI.domain_key}`)
        }
      } else {
        router.push(url)
      }
    }
  } else {
    if (_global_.UI && _global_.UI.domain_key) {
      if (url.indexOf('?') == -1) {
        router.push(`${url}?${_global_.UI.domain_key}`)
      } else {
        router.push(`${url}&${_global_.UI.domain_key}`)
      }
    } else {
      router.push(url)
    }
  }
}
Vue.prototype.toUrl = toUrl

/**
 * 页面带参跳转
 * @param {*} url
 */
window.countdown = function(msec) {
  let startTime = +new Date()
  let endTime = +new Date(msec)
  let t = endTime - startTime
  // console.log(msec);
  // 计算时分秒数
  // let day = parseInt(t / 1000 / 60 / 60 / 24)
  let hr = parseInt((t / 1000 / 60 / 60) % 24)
  let min = parseInt((t / 1000 / 60) % 60)
  let sec = parseInt((t / 1000) % 60)
  // 个位数前补零
  hr = hr > 9 ? hr : '0' + hr
  min = min > 9 ? min : '0' + min
  sec = sec > 9 ? sec : '0' + sec
  return `${hr}:${min}:${sec}`
}

/**
 * 根据跳转参数判断是标题是新增还是编辑
 * @param {*} url
 */
window.changeTitle = function(query) {
  let titles = document.getElementsByClassName('form_title')
  if (titles.length > 0) {
    let title = titles[0]
    let titleText = title.innerHTML
    if (query.pid) {
      title.innerHTML = '编辑' + titleText
    } else {
      title.innerHTML = '新增' + titleText
    }
  }
}

Vue.prototype.changeTitle = changeTitle

_global_.cacheData = new Map()
window.getCache = function(data) {
  let temp = _global_.cacheData.get(window.location.href)
  return temp ? temp : data
}

window.api = function(name, data, cache) {
  if (_global_.uploadIng.length > 0 && name != 'aliyun.sts.verify') {
    alert('文件上传中，请稍后提交.')
    return Promise.reject({})
  }
  let token = getToken()
  let request = {
    method: name,
    debug: service_const.debug
  }
  if (_global_.APPKEY && name !== 'application.switchover') {
    request.app_key = _global_.APPKEY
  }

  if (cache) {
    _global_.cacheData.set(window.location.href, data)
  }
  if (token) {
    request.token = token
  }
  if (data) {
    request.content = data
  }
  console.log('请求数据：' + (data ? JSON.stringify(data) : '无'))

  let url = system.app.api + '/gateway.do'
  if (request.debug) {
    url += '?method=' + name
  }
  return axios.post(url, request).then((res) => {
    return Promise.resolve(res.data)
  })
}

window.alert = function(msg, func) {
  MessageBox.alert(msg, '提示', {
    confirmButtonText: '确定',
    callback: func == undefined ? (action) => {} : func
  })
}

if (!service_const.debug) {
  var targetProtocol = 'https:'
  if (window.location.protocol != targetProtocol) {
    window.location.href = targetProtocol + window.location.href.substring(window.location.protocol.length)
  }
  console.log = function() {}
}

/**
 * 获取Url参数
 */
window.getQuery = function(obj) {
  let query = obj.$route.query
  changeTitle(query)
  return query
}

//正则对象
const Reg = {
  //手机号
  checkPhone: function(rule, value, callback) {
    let reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    let regs = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/
    if (value != null && value != '') {
      if (reg.test(value) || regs.test(value)) {
        callback()
      } else {
        callback(new Error('您输入的手机号有误!'))
      }
    } else if (!value) {
      callback(new Error('该输入项为必填项'))
    } else {
      callback()
    }
  },
  //邮箱
  checkEmail: function(rule, value, callback) {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    if (value) {
      value = value.replace(/\s*/g, '')
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的邮箱'))
      }
    } else {
      callback(new Error('请输入邮箱'))
    }
  },
  //身份证号
  checkIdNumber: function(rule, value, callback) {
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (value != null && value != '') {
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('您输入的身份证号有误!'))
      }
    } else if (!value) {
      callback(new Error('该输入项为必填项'))
    } else {
      callback()
    }
  },
  //纯数字
  checkNumber: function(rule, value, callback) {
    if (/^([0-9]+\.)?[0-9]+$/.test(value)) {
      callback()
    } else if (!value) {
      callback(new Error('该输入项为必填项'))
    } else {
      callback(new Error('只能输入数字'))
    }
  },
  //包含空格
  checkBlank: function(rule, value, callback) {
    let pattern = /\s/
    if (pattern.test(value)) {
      callback(new Error('格式有误(不能包含空格)'))
    } else if (!value) {
      callback(new Error('该输入项为必填项'))
    } else {
      callback()
    }
  },
  makeLinkPhone: function(rule, value, callback) {
    let phone = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/ //手机号
    let fixed = /\d{3}-\d{8}|\d{4}-\d{7}/ //座机号
    if (!value) {
      callback(new Error('该输入项为必填项'))
      return
    }
    if (value.substring(0, 1) == 1) {
      if (phone.test(value)) {
        callback()
      } else {
        callback(new Error('请检查填写的手机号格式(手机号和座机号请选填一个!)'))
      }
    } else if (value.substring(0, 1) === '0') {
      if (fixed.test(value)) {
        callback()
      } else {
        callback(new Error('请检查填写的座机号格式区号用-区分(手机号和座机号请选填一个!)'))
      }
    } else {
      callback(new Error('该输入项为必填项,请选择填写一个手机号或者座机号码!'))
    }
  },
  examinePhone: function(rule, value, callback) {
    let phone = /^[1][1,2,3,4,5,7,8,9][0-9]{9}$/ //手机号
    let fixed = /\d{3}-\d{8}|\d{4}-\d{7}/ //座机号
    if (value.substring(0, 1) == 1) {
      if (phone.test(value)) {
        callback()
      } else {
        callback(new Error('请检查填写的手机号格式(手机号和座机号请选填一个!)'))
      }
    } else if (value.substring(0, 1) === '0') {
      if (fixed.test(value)) {
        callback()
      } else {
        callback(new Error('请检查填写的座机号格式区号用-区分(手机号和座机号请选填一个!)'))
      }
    }
  }
}

/**
 * 表单验证
 */
Vue.prototype.filter_rules = function(isRequire = true, type = '') {
  let rules = []
  switch (type) {
    case 'phone':
      rules.push({
        validator: Reg.checkPhone,
        required: isRequire,
        trigger: 'blur'
      })
      break
    case 'name':
      rules.push({
        validator: Reg.checkBlank,
        required: isRequire,
        trigger: 'blur'
      })
      break
    case 'email':
      rules.push({
        validator: Reg.checkEmail,
        required: isRequire,
        trigger: 'change'
      })
      break
    case 'idNumber':
      rules.push({
        validator: Reg.checkIdNumber,
        required: isRequire,
        trigger: 'blur'
      })
      break
    case 'number':
      rules.push({
        validator: Reg.checkNumber,
        required: isRequire,
        trigger: 'blur'
      })
      break
    case 'radio':
      rules.push({
        required: isRequire,
        message: '该选项为必选项!',
        trigger: 'blur'
      })
      break
    case 'linkman_phone':
      rules.push({
        validator: Reg.makeLinkPhone,
        required: isRequire,
        trigger: 'blur'
      })
      break
    case 'exPhone':
      rules.push({
        validator: Reg.examinePhone,
        required: isRequire,
        trigger: 'blur'
      })
      break
    default:
      rules.push({
        required: isRequire,
        message: '该输入项为必填项!',
        trigger: 'blur'
      })
      break
  }
  return rules
}

/**
 * 表单验证
 */
Vue.prototype.required = function(message) {
  return this.filter_rules()
}



// WEBPACK FOOTER //
// ./src/assets/js/global.js